/*************************************************

* BAKER HUGHES COMPANY CONFIDENTIAL

* Unpublished work copyright 2025 Baker Hughes Company.  All rights reserved.

*

* This computer code is proprietary and highly confidential to Baker Hughes Company

* and/or its affiliate(s). It may not be used, disclosed, modified, transferred,

* or reproduced without prior written consent, and must be returned on demand.

**************************************************/

import { Link, TableColumn } from '@backstage/core-components';
import { DocsTable, DocsTableRow } from '@backstage/plugin-techdocs';
import { Entity } from '@backstage/catalog-model';

function customTitle(entity: Entity): string {
  return entity.metadata.title || entity.metadata.name;
}

const createNameColumn = (): TableColumn<DocsTableRow> => {
  return {
    title: 'Document',
    field: 'entity.metadata.name',
    highlight: true,
    render: (row: DocsTableRow) => (
      <Link to={row.resolved.docsUrl}>{customTitle(row.entity)}</Link>
    ),
  };
};

export const columns: TableColumn<DocsTableRow>[] = [
  createNameColumn(),
  DocsTable.columns.createOwnerColumn(),
  DocsTable.columns.createTypeColumn(),
];
